import HospitalCoverage from '../pages/HospitalCoverage';

const HospitalCoverateRoute = {
  public: [],
  auth: [
    {
      name: 'hospital_coverage_report',
      path: '/dashboard/hospital-coverage',
      permissions: ['HTAM', 'NSM-HOSPITAL', 'SD', 'EXECUTIVE'],
      component: HospitalCoverage,
    },
  ],
};

export default HospitalCoverateRoute;
